module.exports = __webpack_public_path__ + "images/rankingEvents-rank-drop-4abc2de6.svg";